import React from "react";

const ITEMS = [
    {
        n: "I",
        title: "The Monthly Brief",
        body: "One email, the first Tuesday of every month. Under 1,500 words. The macro signals, the policy moves, and the under-reported stories that affect your retirement. Written for adults, not day-traders.",
    },
    {
        n: "II",
        title: "The Quiet Watch",
        body: "A short list at the bottom of every brief: three things we're watching this month, with a sentence each on why.",
    },
    {
        n: "III",
        title: "Plain-English explainers",
        body: "When something complicated happens (Fed pivots, tax-law changes, currency moves), we break it down so a smart 14-year-old could follow it. No charts you need a magnifying glass for.",
    },
    {
        n: "IV",
        title: "No upsells, ever",
        body: "We don\u2019t sell trade alerts, courses, or \u201Cpremium tiers.\u201D If we mention a partner, it\u2019s because we genuinely think it\u2019s worth your time, and we tell you when we\u2019re paid.",
    },
];

export default function WhatsInBrief() {
    return (
        <section
            id="whats-in-brief"
            className="bt-section"
            data-testid="section-whats-in-brief"
            style={{ borderTop: "1px solid var(--bt-rule)" }}
        >
            <div className="bt-shell">
                <div
                    className="bt-promise-grid"
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr",
                        gap: 32,
                        marginBottom: 56,
                    }}
                >
                    <aside style={{ paddingTop: 14 }}>
                        <p className="signal" style={{ marginBottom: 14 }}>
                            № 03
                        </p>
                        <p className="marginalia" style={{ margin: 0, color: "var(--bt-mute)" }}>
                            What you get
                        </p>
                    </aside>
                    <div className="bt-read">
                        <h2 className="t-display" style={{ margin: 0, marginBottom: 20 }}>
                            Four standing sections, one inbox.
                        </h2>
                        <p className="t-lede" style={{ margin: 0 }}>
                            Each issue is short, structured, and built to be read in
                            under ten minutes. The same four sections, every time,
                            so you know where to look.
                        </p>
                    </div>
                </div>

                <ol
                    role="list"
                    data-testid="brief-items"
                    style={{
                        listStyle: "none",
                        padding: 0,
                        margin: 0,
                        borderTop: "1px solid var(--bt-ink)",
                    }}
                >
                    {ITEMS.map((it, i) => (
                        <li
                            key={i}
                            style={{
                                display: "grid",
                                gridTemplateColumns: "minmax(60px, 90px) 1fr",
                                gap: 32,
                                paddingTop: 28,
                                paddingBottom: 28,
                                borderBottom: "1px solid var(--bt-rule)",
                                alignItems: "baseline",
                            }}
                        >
                            <span
                                className="t-numeral"
                                aria-hidden="true"
                                style={{
                                    fontSize: "clamp(28px, 3vw, 40px)",
                                    color: "var(--bt-mute)",
                                }}
                            >
                                {it.n}
                            </span>
                            <div style={{ maxWidth: 720 }}>
                                <h3
                                    className="t-h2"
                                    style={{
                                        margin: 0,
                                        marginBottom: 10,
                                        fontSize: "clamp(22px, 2.4vw, 30px)",
                                    }}
                                >
                                    {it.title}
                                </h3>
                                <p className="t-body" style={{ margin: 0 }}>
                                    {it.body}
                                </p>
                            </div>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    );
}
